import { Automation, ChoicesInterface, WorkflowStepInterface } from '@vendasta/automata';
import { GraphNode } from './automation-graph';
import { TRIGGER_STEP_ID } from '../common/constants';
import { TerminatingSteps } from './component-loader/constants';

export function workflowStepToGraphNode(step: WorkflowStepInterface): GraphNode {
  if (!step) {
    console.error('Step is undefined');
  }

  return {
    stepID: step.id || '',
    childrenStepIDs: [...(step.choices?.rules || []).map((r) => r.next || ''), step.choices?.defaultNextStep || ''],
    terminatingStep: TerminatingSteps.includes(step.taskDefinitionId || ''),
    groupId: step.groupId || '',
  };
}

export function createStepMap(a: Automation | null): Map<string, WorkflowStepInterface> {
  const stepMap = new Map<string, WorkflowStepInterface>();
  if (a?.triggerStep) {
    stepMap.set(a.triggerStep.id, a.triggerStep);
  }
  if (a?.workflow) {
    a.workflow.forEach((workflowStep) => stepMap.set(workflowStep.id, workflowStep));
  }
  return stepMap;
}

export function createWorkflowGraph(
  stepMap: Map<string, WorkflowStepInterface>,
  automation: Automation,
  expandedGroups: Set<string>,
): Map<string, GraphNode> {
  const workflowGraph = new Map<string, GraphNode>();

  for (const step of stepMap.values()) {
    if (!step?.id) {
      continue;
    }
    let newChoices = step.choices;
    if (step.id === TRIGGER_STEP_ID) {
      newChoices = getTriggerStepChoices(automation);
    }
    const graphNode = workflowStepToGraphNode({ ...step, choices: newChoices });

    graphNode.expandedGroup = expandedGroups.has(step.groupId!);

    workflowGraph.set(step.id, graphNode);
  }

  return workflowGraph;
}

function getTriggerStepChoices(automation: Automation): ChoicesInterface {
  if (automation?.triggerFilters?.length > 0) {
    const lastFilter = automation.triggerFilters[automation.triggerFilters.length - 1];
    const lastRule = lastFilter.choices?.rules?.[lastFilter.choices.rules.length - 1];
    return { defaultNextStep: lastRule?.next, rules: [] };
  } else {
    const lastRule = automation.triggerStep.choices?.rules?.[automation.triggerStep.choices.rules.length - 1];
    return { defaultNextStep: lastRule?.next, rules: [] };
  }
}
